<!-- 预警类型 饼图-->
<template>
  <div id="warnningType"></div>
</template>

<script>
export default {
  mounted() {
    this.queryEnvWarningType();
  },
  methods: {
    queryEnvWarningType() {
      this.$api.queryEnvWarningType().then((res) => {
        if (res.code === 200) {
          let list = res.data || [];
          let totalCount = 0;
          list.forEach((item) => {
            totalCount += item.typeProportion;
          });
          this.renderChart(list, totalCount);
        }
      });
    },
    renderChart(list, totalCount) {
      let myChart = this.$echarts.init(document.getElementById("warnningType"));
      let bottomTitle = {
        text: totalCount,
        textStyle: {
          color: "#fff",
          fontSize: 14,
          align: "center",
        },
      };
      let topTitle = {
        text: "设备预警",
        textStyle: {
          fill: "#fff",
          fontSize: 12,
        },
      };
      myChart.setOption({
        title: {
          text: bottomTitle.text,
          left: "center",
          top: "52%",
          textStyle: {
            color: "#fff",
            fontSize: 14,
            align: "center",
          },
        },
        color: ["#c23531", "#d48265", "#91c7ae"],
        graphic: {
          type: "text",
          left: "center",
          top: "45%",
          style: {
            text: topTitle.text,
            textAlign: "center",
            fill: "#fff",
            fontSize: "12",
            //fontWeight: 500,
          },
        },
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            graphic: {
              type: "text",
              left: "center",
              top: "45%",
              style: {
                text: "topTitle",
                textAlign: "center",
                fill: "#fff",
                fontSize: "12",
                //fontWeight: 500,
              },
            },
            label: {
              show: true,
              //   position: "center"
             formatter: "{b}{c}% ",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "20",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: true,
            },
            data: list.map((item) => {
              return {
                name: item.typeName,
                value: item.typeProportion,
              };
            }),
          },
        ],
      });
      //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
  },
};
</script>